var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"main-container"}),_c('v-img',{staticClass:"mx-auto logo",attrs:{"width":_vm.mobile ? '80%': '400px',"src":_vm.siteLogo}}),_c('router-view',{staticClass:"main-content"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }